<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BContainer
      fluid
    >

      <BRow
        class="border-bottom"
      >
        <BCol
          cols="12"
          md="6"
          offset-md="6"
        >
          <ValidationObserver
            ref="formSynchronizer"
            v-slot="{ errors: formErrors }"
          >
            <BRow>

              <BCol
                cols="6"
                md="4"
                class="px-1"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="start_date"
                  name="start date"
                  rules="required"
                >
                  <BFormGroup
                    label="Start Date"
                    label-for="synchronizeStartDate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="synchronizeStartDate"
                      v-model="synchronize.start_date"
                      :state="(errors.length > 0 ? false : null)"
                      :disabled="state.synchronizing"
                      :max="synchronize.end_date"
                      debounce="1000"
                      type="date"
                    />
                    <div
                      v-if="(errors.length > 0)"
                      class="invalid-feedback"
                      v-text="errors[0]"
                    />
                  </BFormGroup>
                </ValidationProvider>
              </BCol>

              <BCol
                cols="6"
                md="4"
                class="px-1"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="end_date"
                  name="end date"
                  rules="required"
                >

                  <BFormGroup
                    label="End Date"
                    label-for="synchronizeEndDate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="synchronizeEndDate"
                      v-model="synchronize.end_date"
                      :state="(errors.length > 0 ? false : null)"
                      :disabled="state.synchronizing"
                      :min="synchronize.start_date"
                      debounce="1000"
                      type="date"
                    />
                    <div
                      v-if="(errors.length > 0)"
                      class="invalid-feedback"
                      v-text="errors[0]"
                    />
                  </BFormGroup>
                </ValidationProvider>
              </BCol>

              <BCol
                cols="6"
                md="4"
                class="px-1 pb-2 d-flex align-items-end"
              >
                <BContainer
                  fluid
                >
                  <BRow>
                    <BCol
                      cols="6"
                      class="pr-1 pl-0"
                    >
                      <BOverlay
                        :show="state.synchronizing"
                        rounded="sm"
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class="p-0"
                      >
                        <BButton
                          :variant="`${state.synchronizing ? 'outline-dark' : 'primary'}`"
                          :disabled="(state.importing || state.synchronizing)"
                          block
                          type="button"
                          @click.prevent="synchronizeSuppliers"
                        >
                          Sync
                        </BButton>
                      </BOverlay>
                    </BCol>
                    <BCol
                      cols="6"
                      class="px-0"
                    >
                      <BOverlay
                        :show="state.importing"
                        rounded="sm"
                        opacity="0.6"
                        spinner-small
                        spinner-variant="warning"
                        :class="[
                          'p-0', {
                            'mb-3 pb-1': (
                              Object.keys(formErrors).filter(
                                error => formErrors[error]?.length > 0
                              ).length > 0
                            )
                          }
                        ]"
                      >
                        <BButton
                          :variant="`${state.importing ? 'outline-dark' : 'warning'}`"
                          :disabled="(state.importing || state.synchronizing)"
                          block
                          type="button"
                          @click.prevent="importSuppliers"
                        >
                          Import
                        </BButton>
                      </BOverlay>
                    </BCol>
                  </BRow>
                </BContainer>
              </BCol>
            </BRow>
          </ValidationObserver>
        </BCol>

      </BRow>

      <BRow
        class="mt-2"
      >

        <BCol
          cols="12"
          class="px-1"
        >
          <BFormGroup
            label="Search"
            label-for="filterSupplierSearch"
            label-class="font-weight-bolder"
          >
            <BFormInput
              id="filterSupplierSearch"
              v-model="tableSuppliers.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
          </BFormGroup>
        </BCol>
      </BRow>

      <BRow
        class="mt-1"
      >
        <BCol
          cols="12"
          class="px-1"
        >
          <BTable
            ref="tableSuppliers"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :items="tableProvider"
            :busy="tableSuppliers.busy"
            :filter="tableSuppliers.filter"
            :fields="tableSuppliers.fields"
            :stacked="tableSuppliers.stacked"
            :sort-by.sync="tableSuppliers.sortBy"
            :sort-desc.sync="tableSuppliers.sortDesc"
            :sort-direction="tableSuppliers.sortDirection"
            :filter-included-fields="tableSuppliers.filterOn"
            :current-page="tableSuppliers.currentPage"
            :per-page="tableSuppliers.perPage"
          >
            <template #cell(index)="{ index }">
              {{ tableRowNumber(tableSuppliers, index) }}
            </template>

            <template #cell()="{ value }">
              <div class="text-md-nowrap">
                {{ value }}
              </div>
            </template>

            <template #cell(action)="{ item }">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <BButton
                  size="sm"
                  variant="primary"
                  @click.prevent="editSupplier(item)"
                >
                  Edit
                </BButton>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <BIcon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </BTable>
        </BCol>

        <BCol
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <BFormSelect
            v-model="tableSuppliers.perPage"
            :options="tableSuppliers.pageOptions"
            :disabled="tableSuppliers.busy"
            class="w-100 w-md-25"
            size="sm"
          />
        </BCol>

        <BCol
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <BPagination
            v-model="tableSuppliers.currentPage"
            :total-rows="tableSuppliers.totalRows"
            :per-page="tableSuppliers.perPage"
            :disabled="tableSuppliers.busy"
            aria-controls="table"
            prev-text="Prev"
            next-text="Next"
            first-number
            last-number
            pills
          />
        </BCol>
      </BRow>

    </BContainer>

    <BModal
      id="modalSupplier"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      title="Edit Supplier"
      aria-hidden="false"
    >
      <ValidationObserver
        ref="formSupplier"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <BRow>

            <BCol
              cols="12"
            >
              <BFormGroup
                label="Code"
                label-for="supplier_code"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="supplier_code"
                  v-model="supplier.supplier_code"
                  type="text"
                  autocomplete="off"
                  maxlength="255"
                  placeholder="no supplier code"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
            >
              <BFormGroup
                label="Name"
                label-for="supplier_name"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="supplier_name"
                  v-model="supplier.supplier_name"
                  type="text"
                  autocomplete="off"
                  maxlength="255"
                  placeholder="no supplier name"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
            >
              <BFormGroup>
                <BFormCheckbox
                  id="is_active"
                  v-model="supplier.active"
                  switch
                  value="1"
                  name="is_active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </BFormCheckbox>
              </BFormGroup>
            </BCol>
          </BRow>

        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <BButton
          variant="primary"
          :disabled="state.busy"
          tabindex="-1"
          @click.prevent="validateSupplier"
        >
          Update Record
        </BButton>
        <BButton
          variant="outline-dark"
          :disabled="state.busy"
          tabindex="-1"
          @click.prevent="$event => {
            $event.target.blur()
            cancel()
          }"
        >
          Close Window
        </BButton>
      </template>

    </BModal>
  </BContainer>
</template>

<script>
import { mapGetters } from 'vuex'

import QUERY from 'lodash'
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import { SAdminSupplier } from '@/services/admin'

export default {
  name: 'VAdminSuppliers',

  middleware: [
    'auth',
    'admin'
  ],

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Suppliers'
  }),

  data () {
    return {
      state: {
        busy: false,
        synchronizing: false,
        importing: false
      },
      synchronize: {
        start_date: '',
        end_date: ''
      },
      supplier: {
        id: '',
        supplier_code: '',
        supplier_name: '',
        active: 1
      },
      tableSuppliers: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 7, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', class: 'min-w-150px', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'supplier_code', class: 'min-w-175px' },
          { mobile: 3, key: 'supplier_name', class: 'min-w-175px' },
          { mobile: 4, key: 'active', class: 'text-center', formatter: this.yesOrNo },
          { mobile: 5, key: 'valid', class: 'text-center' },
          { mobile: 6, key: 'updated_at', class: 'min-w-150px', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {

    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableSuppliers.busy = true
      return await SAdminSupplier.get({
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search
      }).then(({ data }) => {
        this.tableSuppliers.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        this.tableSuppliers.totalRows = 0
        return []
      }).finally(() => {
        this.tableSuppliers.busy = false
      })
    },

    async synchronizeSuppliers () {
      await this.$refs.formSynchronizer.validate().then(
        validSynchronizer => {
          if (!validSynchronizer) {
            return this.swalInvalid()
          }

          this.state.synchronizing = true
          return SAdminSupplier.sync(this.synchronize).then(
            ({ data: { message } }) => {
              this.swalSuccess(message).then(() => {
                this.synchronize.start_date = ''
                this.synchronize.end_date = ''

                this.$refs.formSynchronizer.reset()
                this.$refs.tableSuppliers.refresh()
              })
            }
          ).finally(() => {
            this.state.synchronizing = false
          })
        }
      )
    },

    async importSuppliers () {
      this.state.importing = true
      return SAdminSupplier.import().then(
        ({ data: { message } }) => {
          this.swalSuccess(message).then(() => {
            this.$refs.tableSuppliers.refresh()
          })
        }
      ).finally(() => {
        this.state.importing = false
      })
    },

    editSupplier (supplier) {
      this.supplier.id = supplier.id
      this.supplier.supplier_code = supplier.supplier_code
      this.supplier.supplier_name = supplier.supplier_name
      this.supplier.active = supplier.active

      this.$bvModal.show('modalSupplier')
    },

    async validateSupplier () {
      await this.$refs.formSupplier.validate().then(
        async validSupplier => {
          if (!validSupplier) {
            return this.swalInvalid()
          }

          this.swalConfirm({
            html: '<h6>Save your changes on this Supplier?</h6>',
            preConfirm: () => this.updateSupplier()
          })
        }
      )
    },

    async updateSupplier () {
      this.state.busy = true
      return await SAdminSupplier.put(this.supplier).then(
        ({ data: { message, supplier } }) => {
          this.$bvModal.hide('modalSupplier')
          this.swalSuccess(message).then(() => {
            const tableSuppliersRow = QUERY.find(this.$refs.tableSuppliers.localItems, {
              id: Number(supplier.id)
            })
            if (tableSuppliersRow) {
              tableSuppliersRow.supplier_code = supplier.supplier_code
              tableSuppliersRow.supplier_name = supplier.supplier_name
              tableSuppliersRow.active = supplier.active
              tableSuppliersRow.valid = supplier.valid
              tableSuppliersRow.updated_at = supplier.updated_at
            }
          })
        }
      ).catch(({ message }) => {
        if (message) {
          this.$refs.formSupplier.setErrors(message)
        }
      }).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
